import Api from "../../services/api";

export const getUser = (api: Api, userId: string) => {
    return new Promise<IUser>((resolve, reject) => {
        api.call(
            "Get",
            {
                typeName: "User",
                search: { id: userId }
            },
            users => {
                users && users[0] ? resolve(users[0]) : reject({ message: `No user with id ${ userId } found` });
            },
            error =>
            reject(error)
        );
    });
};

export const setUser = (api: Api, user: IUser) => {
    return new Promise<void>((resolve, reject) => {
        api.call(
            "Set",
            {
                typeName: "User",
                entity: user
            },
            () => resolve(),
            error => reject(error)
        );
    });
};